import ModalGallerySlider from "../components/ModalGallerySlider";

export default {
    init() {
        const gallerySwiper = new ModalGallerySlider($('#modal-gallery-page'));

        $('a.toggle-gallery-modal').on('click', function (e) {
            e.preventDefault();
            const targetModal = $(this).data('target');
            const swipeIdx = parseInt($(this).data('swipe-index'));
            $(targetModal).addClass('active');
            gallerySwiper.swiper.update();
            gallerySwiper.swiper.slideTo(swipeIdx);
        });
    },

    finalize() {
        // JavaScript to be fired on the home page, after the init JS
    }
};